import styled from '@emotion/styled';
import { COLORS } from './constants';
import type { IconStatusWrapperColors, IconStatusWrapperProps } from './types';

export const Wrapper = styled.div<
  Pick<IconStatusWrapperProps, 'color' | 'invertColors' | 'size' | 'variant'>
>`
  border-radius: 50%;
  display: flex;
  align-items: center;
  padding: ${props => props.theme.spacing(1)};
  font-size: 16px;

  &.icon-small {
    font-size: 16px;
    padding: ${props => props.theme.spacing(0.5)};
  }

  &.icon-medium {
    font-size: 24px;
    padding: ${props => props.theme.spacing(1.5)};
  }

  ${props => {
    const providedColor: IconStatusWrapperColors = props.color;
    let color = undefined;
    let backgroundColor = props.theme.palette.gray[100];
    const isCustom = !!providedColor && !COLORS.includes(providedColor);

    if (isCustom) {
      backgroundColor = providedColor;
    }

    if (!props.invertColors && providedColor && props.theme.palette[providedColor]?.['200']) {
      backgroundColor = props.theme.palette[providedColor]['200'];
    }

    if (props.invertColors && providedColor && props.theme.palette[providedColor]?.['500']) {
      backgroundColor = props.theme.palette[providedColor]['500'];
      color = props.theme.palette.common.white;
    }

    return { backgroundColor, color, ...(props.variant === 'rounded' ? { borderRadius: 4 } : {}) };
  }}
`;
